import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as productActions from '../_actions/product';
import { Product } from '../_models';

export interface ProductState extends EntityState<Product> {
  loading: boolean;
  loaded: boolean;
  error: any;
}

export const adapter: EntityAdapter<Product> = createEntityAdapter<Product>();

const initialState: ProductState = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

const productReducer = createReducer(
  initialState,

  on(productActions.loadProducts, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),

  on(productActions.loadProductsSuccess, (state, { products }) =>
    adapter.setAll(products, { ...state, loaded: true, loading: false })
  ),

  on(productActions.loadProductsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error,
  })),

  on(productActions.addProductSuccess, (state, { product }) => adapter.addOne(product, state)),
  on(productActions.addManyProductsSuccess, (state, { products }) =>
    adapter.addMany(products, state)
  ),

  on(productActions.updateProductSuccess, (state, { product }) =>
    adapter.upsertOne(product, state)
  ),

  on(productActions.deleteProductSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    productActions.addProductFailure,
    productActions.updateProductFailure,
    productActions.deleteProductFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: ProductState | undefined, action: Action) {
  return productReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
